import React, { useContext, useRef, useState } from 'react';
import { Item } from 'devextreme-react/form';
import FilieraContext from '../../../contexts/filieraContext';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Editing,
    Form,
    Button,
    Lookup,
    Format,
    ToolbarItem,
    Toolbar
} from 'devextreme-react/data-grid';
import { listiniAnimaliDettaglioDataSource } from '../../../datasources/listiniAnimaliDettagliDataSource';
import { TipiAnimaliDataSource } from '../../../datasources/tipiAnimaliDataSource';
import { dataGridErrorHandling } from '../../../utils/errorHandling';
import { capannoniDataSource } from '../../../datasources/capannoniDataSource';
import { ListinoDTO } from '../../../data';
import { Box, Switch } from 'devextreme-react';

type AnimaliTableProps = {
    listino: ListinoDTO,
    idListino: number,
    onChanged: ()=>void,
    readonly?: boolean
};

const AnimaliDettaglio: React.FC<AnimaliTableProps> = (params) => {
    const { currentFiliera } = useContext(FilieraContext);
    const [ showAll, setShowAll ] = useState <boolean> (false);
     const gridRef = useRef<DataGrid>(null);

   function refreshGrid() {
        gridRef.current?.instance.refresh();
    }

    const new_click = () => {
        if (!gridRef.current) return;
        gridRef.current.instance.addRow();
        gridRef.current.instance.editRow(gridRef.current.instance.getRowIndexByKey(0));
    };


    const styles = {
        alignTitle: {
        marginLeft: "40px",
        marginRight: "40px",
        },
        fixSwitch: {
        width: "unset"
        }
    };

    return (
        <React.Fragment>
           <Box
                direction="row"
                width="100%"
                height={20}
                align="center"
                crossAlign="center">
                <Item colSpan={2}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ whiteSpace: 'nowrap' }}>Mostra tutti</span>
                        <Switch defaultValue={showAll} onValueChange={setShowAll} />
                    </div>
                </Item>
            </Box>
            <DataGrid
                className={'dx-card wide-card'}
                dataSource={listiniAnimaliDettaglioDataSource(params.idListino, showAll)}
                showBorders={false}
                focusedRowEnabled={true}
                defaultFocusedRowIndex={0}
                defaultSelectionFilter=""
                columnAutoWidth={true}
                errorRowEnabled={false}
                columnHidingEnabled={true}
                onRowUpdating={function (e) {
                    e.newData = Object.assign({}, e.oldData, e.newData);
                }}
                onRowRemoved={params.onChanged}
                onRowUpdated={params.onChanged}
                onRowInserted={params.onChanged}
                onDataErrorOccurred={dataGridErrorHandling}
            >
                <Editing mode="popup" allowAdding={true} allowUpdating={true}  allowDeleting={true} >
                    <Form labelMode='floating'>
                        <Item itemType="group" caption="Informazioni Listini Animali dettagliato" colCount={3} colSpan={2}>
                            <Item dataField="idTipoAnimale" editorType="dxSelectBox" editorOptions={{ searchEnabled: true }} />
                            <Item 
                                dataField="inizioValidita" 
                                editorType="dxDateBox" 
                                editorOptions={{
                                    type: 'date', // Ensures only the date is used
                                    displayFormat: 'yyyy-MM-dd', // Use a standard date format
                                    useMaskBehavior: true, // Ensures the format mask is applied
                                }} 
                            />
                            <Item dataField="valore" editorType='dxNumberBox'/>
                        </Item>
                    </Form>
                </Editing>
                <Paging defaultPageSize={10} />
                <Pager showPageSizeSelector={true} showInfo={true} />
                <FilterRow visible={true} />

                <Column type="buttons">
                    <Button name="edit" />
                    <Button name="delete" />
                </Column>
                <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
                <Column dataField={'idListino'} width={90} allowEditing={false} visible={false} />
                <Column dataField={'inizioValidita'} alignment='right' width={200}/>
                <Column dataField={'idTipoAnimale'} caption={'Descrizione Tipo Animale'} visible={false} hidingPriority={7}>
                    <Lookup dataSource={TipiAnimaliDataSource()} valueExpr="id" displayExpr={"descrizione"}/>
                </Column>
                <Column dataField={'valore'} caption='Prezzo/Capo' >
                    <Format type='currency' precision={4}></Format>
                </Column>
                <Column dataField={'tipoAnimale.codice'} caption={'Codice Tipo Animale'} hidingPriority={4} alignment='right' />
                <Column dataField={'tipoAnimale.maschio'} caption={'Maschio'} hidingPriority={2} />
                <Column dataField={'tipoAnimale.razza.descrizione'} caption={'Descrizione Razza'} hidingPriority={1} />

                <Toolbar>
                    <ToolbarItem location="after">
                        <Button icon="refresh" onClick={refreshGrid} />
                    </ToolbarItem>
                    <ToolbarItem location="after">
                        <Button
                            icon="add"
                            onClick={new_click}
                            disabled={params.readonly}
                        />
                    </ToolbarItem>
                </Toolbar>
            </DataGrid>
            
        </React.Fragment>
    );
};

export default AnimaliDettaglio;